import Filter from '../Filter';
import Sort from '../Sort';
import {getPaginatedUsers} from '../../api/admin/UserApi';

export default class UserFilter extends Filter {
  constructor(data) {
    super(data);

    this.name = data?.name;
    this.email = data?.email;
    this.status = data?.status;

    this.sorts = {
      name: data?.sorts?.name ?? new Sort(),
      email: data?.sorts?.email ?? new Sort(),
      status: data?.sorts?.status ?? new Sort(),
    }
  }

  get key() {
    return 'users';
  }

  get paginatedFetcher() {
    return async () => await getPaginatedUsers(this);
  }
}
